import { Component, Input, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-mentions-legales',
  templateUrl: './mentions-legales.component.html',
  styleUrls: ['./mentions-legales.component.scss']
})
export class MentionsLegalesComponent implements OnInit {

  constructor(private title: Title) {
    this.title.setTitle('Mentions Légales - Office notarial Pacé');
  }

  ngOnInit(): void {
  }

}
